module.exports = __webpack_public_path__ + "assets/images/math.3e461d4bc7a6dfe8fd04426b80770bbd.svg";